import React, { useState } from "react";
import search from "../helpers/search";

const Search = ({students, nameInput, tagInput, inputField,setNameInput,setTagInput})=> {
  const [inputVal, setInputVal] = useState("");

  const onChangeHandler = (e) => {
    const {value} = e.target;
    setInputVal(value);
    if(inputField==="name") setNameInput(value);
    if(inputField==="tag") setTagInput(value);
    search(students, nameInput, tagInput);
  };
    const style = {
      width: "100%",
      border: "none",
      outline: "none",
      borderBottom: "2px solid grey",
      marginBottom: "1.3em",
    };
    return (
      <React.Fragment>
        <form action="#" onSubmit={(e)=>e.preventDefault()} className="text-center mt-2">
          <input
            value={inputVal}
            style={style}
            placeholder={
              inputField === "name"
                ? "Search By Name..."
                : "Search By Tag..."
            }
            type="text"
            onChange={onChangeHandler}
          />
        </form>
      </React.Fragment>
    );
}
export default Search;